import styled from 'styled-components';

//helpers
import { screen } from '@/helpers/screen';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

//theme
import { homeColor } from '@/theme/ai';

export const HeroSection = styled.header`
  position: relative;
  overflow: hidden;
  background: radial-gradient(
    ellipse 78% 68% at 26% 28%,
    #0f555c 0%,
    #0c3f45 21%,
    #0a282d 42%,
    ${homeColor.bg} 86%
  );
`;

export const HeroInner = styled.div`
  padding: 40px 29px;
  display: flex;
  flex-direction: column;
  gap: 32px;

  ${screen.md} {
    padding: 60px 47px;
  }

  ${screen.lg} {
    padding: 80px 126px 40px;
    gap: 40px;
  }

  ${screen.xxlg} {
    max-width: 1920px;
    margin: 0 auto;
    padding: 80px 280px 40px;
  }
`;

export const HeroTop = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  align-items: center;

  ${screen.lg} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 32px;
  }
`;

export const HeroCopy = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 640px;
  text-align: center;

  ${screen.lg} {
    text-align: left;
  }
`;

export const Eyebrow = styled.p`
  font-family: ${getToken('font-family-default')};
  font-weight: 600;
  color: ${homeColor.green};
  font-size: 12px;
  letter-spacing: 0.13em;
  margin: 0;
`;

export const HeroTitle = styled.h1`
  font-family: ${getToken('font-family-title')};
  font-weight: 800;
  letter-spacing: -0.025em;
  line-height: 1.08;
  font-size: 50px;
  margin: 0;
  color: ${homeColor.white};
`;

export const HeroSub = styled.p`
  font-family: ${getToken('font-family-default')};
  font-weight: 500;
  font-size: 17px;
  line-height: 1.6;
  color: ${homeColor.muted};
  margin: 0;

  b {
    color: ${homeColor.white};
    font-weight: 600;
  }
`;

export const CtaRow = styled.div`
  display: flex;
  justify-content: center;

  ${screen.lg} {
    justify-content: flex-start;
  }
`;

export const HeroImageWrap = styled.div`
  flex: none;
  width: 100%;
  max-width: 460px;
`;
